import React from 'react'

export function UserWhite() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M12 2.75a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5zM7.25 6a4.75 4.75 0 119.5 0 4.75 4.75 0 01-9.5 0zM2.25 22c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75a.75.75 0 01-1.5 0 8.25 8.25 0 00-16.5 0 .75.75 0 01-1.5 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}
